import React from 'react';
import { HeroSection } from '../components/HeroSection';
import { IdentificacionSection } from '../components/IdentificacionSection';
import { ProblemaRealSection } from '../components/ProblemaRealSection';
import { RevelacionSection } from '../components/RevelacionSection';
import { SolucionSection } from '../components/SolucionSection';
import { FormularioSection } from '../components/FormularioSection';
import { IdentidadSection } from '../components/IdentidadSection';
import { TransicionSection } from '../components/TransicionSection';
import { FraseFinalSection } from '../components/FraseFinalSection';
import { Footer } from '../components/Footer';
export function LandingPage() {
  return <main className="min-h-screen w-full font-sans selection:bg-[#FF6B00] selection:text-white" data-id="element-156">
      <HeroSection data-id="element-157" />
      <IdentificacionSection data-id="element-158" />
      <ProblemaRealSection data-id="element-159" />
      <RevelacionSection data-id="element-160" />
      <SolucionSection data-id="element-161" />
      <FormularioSection data-id="element-162" />
      <IdentidadSection data-id="element-163" />
      <TransicionSection data-id="element-164" />
      <FraseFinalSection data-id="element-165" />
      <Footer data-id="element-166" />
    </main>;
}